import { useEffect } from "react";
import { toast } from "react-toastify";
import NewVersionToast from "./NewVersionToast";
import "./NewVersionBanner.scss";
import { useVersionCheck } from "../../../hooks/useVersionCheck";

const TOAST_ID = "new-version";

function NewVersionBanner() {
    const { isNewVersionAvailable } = useVersionCheck();

    useEffect(() => {
        if (!isNewVersionAvailable) return;
        if (toast.isActive(TOAST_ID)) return;
        toast(<NewVersionToast />, {
            toastId: TOAST_ID,
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
            draggable: false,
            position: "bottom-right",
            className: "nvt-container",
            icon: false,
        });
    }, [isNewVersionAvailable]);

    return null;
}

export default NewVersionBanner;
